'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n      justify-content: center;\n      text-align: center;\n    '], ['\n      justify-content: center;\n      text-align: center;\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n      flex-basis: 0;\n      flex-grow: 1;\n      max-width: 100%;\n      -ms-flex-positive: 1;\n    '], ['\n      flex-basis: 0;\n      flex-grow: 1;\n      max-width: 100%;\n      -ms-flex-positive: 1;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      flex-basis: 8.33333333%;\n      max-width: 8.33333333%;\n      -ms-flex-preferred-size: 8.33333333%;\n    '], ['\n      flex-basis: 8.33333333%;\n      max-width: 8.33333333%;\n      -ms-flex-preferred-size: 8.33333333%;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      flex-basis: 16.66666667%;\n      max-width: 16.66666667%;\n      -ms-flex-preferred-size: 16.66666667%;\n    '], ['\n      flex-basis: 16.66666667%;\n      max-width: 16.66666667%;\n      -ms-flex-preferred-size: 16.66666667%;\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n      flex-basis: 25%;\n      max-width: 25%;\n      -ms-flex-preferred-size: 25%;\n    '], ['\n      flex-basis: 25%;\n      max-width: 25%;\n      -ms-flex-preferred-size: 25%;\n    ']),
    _templateObject6 = _taggedTemplateLiteral(['\n      flex-basis: 33.33333333%;\n      max-width: 33.33333333%;\n      -ms-flex-preferred-size: 33.33333333%;\n    '], ['\n      flex-basis: 33.33333333%;\n      max-width: 33.33333333%;\n      -ms-flex-preferred-size: 33.33333333%;\n    ']),
    _templateObject7 = _taggedTemplateLiteral(['\n      flex-basis: 41.66666667%;\n      max-width: 41.66666667%;\n      -ms-flex-preferred-size: 41.66666667%;\n    '], ['\n      flex-basis: 41.66666667%;\n      max-width: 41.66666667%;\n      -ms-flex-preferred-size: 41.66666667%;\n    ']),
    _templateObject8 = _taggedTemplateLiteral(['\n      flex-basis: 50%;\n      max-width: 50%;\n      -ms-flex-preferred-size: 50%;\n    '], ['\n      flex-basis: 50%;\n      max-width: 50%;\n      -ms-flex-preferred-size: 50%;\n    ']),
    _templateObject9 = _taggedTemplateLiteral(['\n      flex-basis: 58.33333333%;\n      max-width: 58.33333333%;\n      -ms-flex-preferred-size: 58.33333333%;\n    '], ['\n      flex-basis: 58.33333333%;\n      max-width: 58.33333333%;\n      -ms-flex-preferred-size: 58.33333333%;\n    ']),
    _templateObject10 = _taggedTemplateLiteral(['\n      flex-basis: 66.66666667%;\n      max-width: 66.66666667%;\n      -ms-flex-preferred-size: 66.66666667%;\n    '], ['\n      flex-basis: 66.66666667%;\n      max-width: 66.66666667%;\n      -ms-flex-preferred-size: 66.66666667%;\n    ']),
    _templateObject11 = _taggedTemplateLiteral(['\n      flex-basis: 75%;\n      max-width: 75%;\n      -ms-flex-preferred-size: 75%;\n    '], ['\n      flex-basis: 75%;\n      max-width: 75%;\n      -ms-flex-preferred-size: 75%;\n    ']),
    _templateObject12 = _taggedTemplateLiteral(['\n      flex-basis: 83.33333333%;\n      max-width: 83.33333333%;\n      -ms-flex-preferred-size: 83.33333333%;\n    '], ['\n      flex-basis: 83.33333333%;\n      max-width: 83.33333333%;\n      -ms-flex-preferred-size: 83.33333333%;\n    ']),
    _templateObject13 = _taggedTemplateLiteral(['\n      flex-basis: 91.66666667%;\n      max-width: 91.66666667%;\n      -ms-flex-preferred-size: 91.66666667%;\n    '], ['\n      flex-basis: 91.66666667%;\n      max-width: 91.66666667%;\n      -ms-flex-preferred-size: 91.66666667%;\n    ']),
    _templateObject14 = _taggedTemplateLiteral(['\n      flex-basis: 100%;\n      max-width: 100%;\n      -ms-flex-preferred-size: 100%;\n    '], ['\n      flex-basis: 100%;\n      max-width: 100%;\n      -ms-flex-preferred-size: 100%;\n    ']),
    _templateObject15 = _taggedTemplateLiteral(['\n      margin-left: 8.33333333%;\n    '], ['\n      margin-left: 8.33333333%;\n    ']),
    _templateObject16 = _taggedTemplateLiteral(['\n      margin-left: 16.66666667%;\n    '], ['\n      margin-left: 16.66666667%;\n    ']),
    _templateObject17 = _taggedTemplateLiteral(['\n      margin-left: 25%;\n    '], ['\n      margin-left: 25%;\n    ']),
    _templateObject18 = _taggedTemplateLiteral(['\n      margin-left: 33.33333333%;\n    '], ['\n      margin-left: 33.33333333%;\n    ']),
    _templateObject19 = _taggedTemplateLiteral(['\n      margin-left: 41.66666667%;\n    '], ['\n      margin-left: 41.66666667%;\n    ']),
    _templateObject20 = _taggedTemplateLiteral(['\n      margin-left: 50%;\n    '], ['\n      margin-left: 50%;\n    ']),
    _templateObject21 = _taggedTemplateLiteral(['\n      margin-left: 58.33333333%;\n    '], ['\n      margin-left: 58.33333333%;\n    ']),
    _templateObject22 = _taggedTemplateLiteral(['\n      margin-left: 66.66666667%;\n    '], ['\n      margin-left: 66.66666667%;\n    ']),
    _templateObject23 = _taggedTemplateLiteral(['\n      margin-left: 75%;\n    '], ['\n      margin-left: 75%;\n    ']),
    _templateObject24 = _taggedTemplateLiteral(['\n      margin-left: 83.33333333%;\n    '], ['\n      margin-left: 83.33333333%;\n    ']),
    _templateObject25 = _taggedTemplateLiteral(['\n      margin-left: 91.66666667%;\n    '], ['\n      margin-left: 91.66666667%;\n    ']),
    _templateObject26 = _taggedTemplateLiteral(['\n      justify-content: flex-end;\n      text-align: end;\n    '], ['\n      justify-content: flex-end;\n      text-align: end;\n    ']),
    _templateObject27 = _taggedTemplateLiteral(['\n      padding-left: 0;\n      padding-right: 0;\n    '], ['\n      padding-left: 0;\n      padding-right: 0;\n    ']),
    _templateObject28 = _taggedTemplateLiteral(['\n      flex-direction: column-reverse;\n    '], ['\n      flex-direction: column-reverse;\n    ']),
    _templateObject29 = _taggedTemplateLiteral(['\n      justify-content: flex-start;\n      text-align: start;\n    '], ['\n      justify-content: flex-start;\n      text-align: start;\n    ']),
    _templateObject30 = _taggedTemplateLiteral(['\n  ', '\n  box-sizing: border-box;\n  flex: 0 0 auto;\n  padding: ', ';\n  position: relative;\n  ', '\n  ', '\n'], ['\n  ', '\n  box-sizing: border-box;\n  flex: 0 0 auto;\n  padding: ', ';\n  position: relative;\n  ', '\n  ', '\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactiveContainer = require('reactive-container');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsModifiers = require('styled-components-modifiers');

var _styledComponentsThemeValidator = require('styled-components-theme-validator');

var _modifiers = require('./utils/modifiers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var COMPONENT_NAME = 'Column';

var MODIFIER_CONFIG = _extends({}, _modifiers.dimensionModifiers, _modifiers.displayModifiers, _modifiers.padScaleModifiers, {
  center: function center() {
    return {
      styles: (0, _styledComponents.css)(_templateObject)
    };
  },
  col: function col() {
    return {
      styles: (0, _styledComponents.css)(_templateObject2)
    };
  },
  col_1: function col_1() {
    return {
      styles: (0, _styledComponents.css)(_templateObject3)
    };
  },
  col_2: function col_2() {
    return {
      styles: (0, _styledComponents.css)(_templateObject4)
    };
  },
  col_3: function col_3() {
    return {
      styles: (0, _styledComponents.css)(_templateObject5)
    };
  },
  col_4: function col_4() {
    return {
      styles: (0, _styledComponents.css)(_templateObject6)
    };
  },
  col_5: function col_5() {
    return {
      styles: (0, _styledComponents.css)(_templateObject7)
    };
  },
  col_6: function col_6() {
    return {
      styles: (0, _styledComponents.css)(_templateObject8)
    };
  },
  col_7: function col_7() {
    return {
      styles: (0, _styledComponents.css)(_templateObject9)
    };
  },

  col_8: function col_8() {
    return {
      styles: (0, _styledComponents.css)(_templateObject10)
    };
  },

  col_9: function col_9() {
    return {
      styles: (0, _styledComponents.css)(_templateObject11)
    };
  },
  col_10: function col_10() {
    return {
      styles: (0, _styledComponents.css)(_templateObject12)
    };
  },
  col_11: function col_11() {
    return {
      styles: (0, _styledComponents.css)(_templateObject13)
    };
  },
  col_12: function col_12() {
    return {
      styles: (0, _styledComponents.css)(_templateObject14)
    };
  },
  col_offset_1: function col_offset_1() {
    return {
      styles: (0, _styledComponents.css)(_templateObject15)
    };
  },
  col_offset_2: function col_offset_2() {
    return {
      styles: (0, _styledComponents.css)(_templateObject16)
    };
  },
  col_offset_3: function col_offset_3() {
    return {
      styles: (0, _styledComponents.css)(_templateObject17)
    };
  },
  col_offset_4: function col_offset_4() {
    return {
      styles: (0, _styledComponents.css)(_templateObject18)
    };
  },
  col_offset_5: function col_offset_5() {
    return {
      styles: (0, _styledComponents.css)(_templateObject19)
    };
  },
  col_offset_6: function col_offset_6() {
    return {
      styles: (0, _styledComponents.css)(_templateObject20)
    };
  },
  col_offset_7: function col_offset_7() {
    return {
      styles: (0, _styledComponents.css)(_templateObject21)
    };
  },
  col_offset_8: function col_offset_8() {
    return {
      styles: (0, _styledComponents.css)(_templateObject22)
    };
  },
  col_offset_9: function col_offset_9() {
    return {
      styles: (0, _styledComponents.css)(_templateObject23)
    };
  },
  col_offset_10: function col_offset_10() {
    return {
      styles: (0, _styledComponents.css)(_templateObject24)
    };
  },
  col_offset_11: function col_offset_11() {
    return {
      styles: (0, _styledComponents.css)(_templateObject25)
    };
  },
  end: function end() {
    return {
      styles: (0, _styledComponents.css)(_templateObject26)
    };
  },
  fluid: function fluid() {
    return {
      styles: (0, _styledComponents.css)(_templateObject27)
    };
  },
  reverse: function reverse() {
    return {
      styles: (0, _styledComponents.css)(_templateObject28)
    };
  },
  start: function start() {
    return {
      styles: (0, _styledComponents.css)(_templateObject29)
    };
  }
});

var THEME_PROPTYPES = (0, _styledComponentsThemeValidator.buildThemePropTypes)({
  dimensions: _propTypes2.default.shape({
    gridPad: _propTypes2.default.string.isRequired
  }).isRequired
});

var Column = _styledComponents2.default.div(_templateObject30, (0, _styledComponentsThemeValidator.validateTheme)(COMPONENT_NAME, THEME_PROPTYPES), function (props) {
  return props.theme.dimensions.gridPad;
}, (0, _styledComponentsModifiers.applyStyleModifiers)(MODIFIER_CONFIG), (0, _styledComponentsModifiers.applyResponsiveStyleModifiers)(MODIFIER_CONFIG));

Column.propTypes = {
  className: _propTypes2.default.string,
  modifiers: (0, _styledComponentsModifiers.styleModifierPropTypes)(MODIFIER_CONFIG),
  responsiveModifiers: (0, _styledComponentsModifiers.responsiveStyleModifierPropTypes)(MODIFIER_CONFIG),
  size: _propTypes2.default.string.isRequired
};

Column.defaultProps = {
  className: COMPONENT_NAME
};

var ColumnWithSize = (0, _reactiveContainer.withSize)(Column);

ColumnWithSize.displayName = COMPONENT_NAME;
ColumnWithSize.modifiers = MODIFIER_CONFIG;

exports.default = ColumnWithSize;


//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-components-reactive-grid/dist/Column.js
// module id = 1431
// module chunks = 2